module.exports = __webpack_public_path__ + "static/media/coyotte2.b6f253c4.png";